
import axios from '~/util/axios'
import { mapMutations } from 'vuex'
// homehub mixin should not be used for shared or sub components; only page components (exception is LandingHeroBanner)
export default {
  name: 'homehubMixin',
  data () {
    return {
      btnLoading: false,
      params: {
        code: this.$route.params.code,
        locale: this.$route.params.locale
      },
      query: {
        email: this.$route.query.email,
        first_name: this.$route.query.first_name,
        last_name: this.$route.query.last_name,
        phone: this.$route.query.phone,
        from_mobile_share: this.$route.query.from_mobile_share,
        error: this.$route.query.error
      },
      supportText: 'Something went wrong. Please try again later.'
    }
  },
  created () {
    if (this.canTransitionHere) {
      this.$store.viewed.push(this.$route.name)
    } else {
      this.logError({
        errorMessage: `Prohibited transition to ${this.$route.name}`,
        redirect: true,
        postSentry: false
      })
    }
  },
  methods: {
    ...mapMutations('toast', ['setToast']),
    async performTransition () {
      const state = this.$store.response?.data?.current_state
      const name = this.transitionMap[state]
      if (name) {
        this.$router.push({ name, params: this.params, query: this.query })
      } else if (state === 'auth_signed_in') {
        this.$store.response = await this.persistSession()
        if (this.serverError) return this.handleApiError()
        if (this.sessionError) return this.handleSessionError()
        window.location.href = this.$store.response.data
      } else if (state === 'reported') {
        this.btnLoading = false
        this.setToast({
          event: 'error',
          message: this.$store.borrowerWebContent?.whitelistError,
          type: 'sticky'
        })
      } else {
        this.btnLoading = false
        this.setToast({
          event: 'error',
          message: this.supportText,
          type: 'sticky'
        })
        this.logError({
          errorMessage: `Unhandled state ${state} in ${this.$route.name}`,
          postSentry: true
        })
      }
    },
    handleSessionError () {
      this.btnLoading = false
      switch (this.$store.response?.data) {
        case 'InvalidLogin': // lo password reset flow
          return this.$router.push({ name: 'signIn', params: this.params, query: this.query })
        case 'prohibited': // white listing
          return this.setToast({
            event: 'error',
            message: this.$store.borrowerWebContent?.whitelistError,
            type: 'sticky'
          })
        default:
          return this.handleApiError()
      }
    },
    persistState () {
      const { data } = this.$store.response
      if (data.values) {
        this.$store.responseValues = {
          ...this.$store.responseValues,
          ...data.values
        }
      }
      if (data.authenticated_data) {
        this.$store.authenticatedData = data.authenticated_data
      }
    },
    async persistSession () {
      return await axios.post('/sessions', {
        authenticity_token: document.getElementsByName('csrf-token')[0].content,
        email: this.$store.userEmail,
        fromLogin: true,
        token: this.$store.authenticatedData?.token,
        sac_id: this.$store.authenticatedData?.sac_id,
        user_id: this.$store.authenticatedData?.user?.id,
        fromMobileShare: this.query.from_mobile_share === 'true'
      })
    },
    logError (options) {
      if (options.postSentry === true) {
        this.$sentry.captureEvent({
          message: options.errorMessage,
          extra: {
            store: this.$store,
            response: options.response
          }
        })
      } else {
        console.log(options.errorMessage)
      }
      if (options.redirect === true) {
        this.$router.replace({
          name: options?.newRoute || this.defaultRoute,
          params: this.params,
          query: this.query
        })
      }
    },
    handleApiError () {
      this.btnLoading = false
      this.setToast({
        event: 'error',
        message: this.supportText,
        type: 'sticky'
      })
      this.logError({
        errorMessage: this.$store.response?.data?.error || 'Server failed to return a response',
        response: this.$store.response,
        postSentry: true
      })
    },
    async chainApiCalls (calls = [], handleSuccess = () => undefined) {
      for (let i = 0; i < calls.length; i++) {
        const {
          condition = () => true,
          callback = () => undefined,
          rescue = () => false,
          onRescue = () => undefined,
          onSuccess = () => undefined,
          forceReturn = false
        } = calls[i]
        if (condition()) {
          this.$store.response = await callback()
          if (this.serverError) {
            if (rescue()) {
              await onRescue()
            } else {
              this.handleApiError()
              return
            }
          } else {
            await onSuccess()
          }
          if (forceReturn) return
        }
      }
      await handleSuccess()
    }
  },
  computed: {
    defaultRoute () {
      switch (true) {
        case this.$store.viewed[0] === 'signIn':
          return 'signIn'
        case this.$store.viewed[0] === 'askForEmail':
          return 'askForEmail'
        case this.$store.viewed[0] === 'registerAccount':
          return 'registerAccount'
        default:
          return 'landingPage'
      }
    },
    transitionMap () {
      return {
        auth_input_email: this.$store.userClickedForgotPassword ? 'recoverPassword' : 'askForEmail',
        auth_choose_servicer: 'multipleLoanOfficers',
        auth_choose_expert: 'selectLoanOfficer',
        auth_send_verification: this.$store.response?.data?.current_state_definition?.redirect ? 'signIn' : 'sendVerificationCode',
        auth_send_verification_email_only: this.$store.response?.data?.current_state_definition?.redirect ? 'signIn' : 'sendVerificationCode',
        auth_ssn_verification: this.$store.response?.data?.current_state_definition?.redirect ? 'registerAccount' : 'enterVerificationCode',
        auth_waiting_for_verification: 'enterVerificationCode',
        auth_validate_name: 'validateName',
        auth_validate_phone: 'validatePhone',
        new_choose_expert: 'selectLoanOfficer',
        new_inputs_combined: 'registerAccount',
        new_input_email: 'askForEmail',
        post_auth_grant_loan_access: 'grantLoanAccess',
        post_auth_set_new_password: 'setPassword',
        post_auth_terms_and_conditions: 'termsAndConditions',
        auth_waiting_for_recover_password_verification: 'passwordEmail',
        post_auth_waiting_for_email_verification: 'verifyEmail',
        new_email_confirmation: this.$store.response?.data?.current_state_definition?.redirect ? 'signIn' : 'emailConfirmation'
      }
    },
    serverFailed () {
      return this.$store.response === undefined || (typeof this.$store.response === 'object' && this.$store.response !== null && this.$store.response.status !== 200)
    },
    serverError () {
      return this.serverFailed || (typeof this.$store.response?.data === 'object' && this.$store.response?.data !== null && !!this.$store.response.data.error)
    },
    sessionError () {
      return ['AccountLocked', 'CompanyDisabled', 'AccountDisabled', 'InvalidLogin', 'prohibited'].includes(this.$store.response?.data)
    },
    isMobile () {
      return !!(/ipad|iphone|ipod|android|kindle fire|silk-accelerated/i.test(navigator.userAgent))
    }
  }
}
